export const trackEvent = (event: string, params: any = {}) => {
  const userId = localStorage.getItem("userId");
  if (!event) {
    return null;
  }
  try {
    return window.Moengage.track_event(event, { leap_id: userId, ...params });
  } catch (e) {
    console.error(e);
  }
};

export const analyticsLogin = (userId: string) => {
  window.Moengage.add_unique_user_id(userId);
};

export const analyticsLogout = () => {
  window.Moengage.destroy_session();
};

// INFO: this can be used rather than hardcoding and this also gives typesafety - have used closure
// interface ICommonPropertiesObjGeneratorParams {
//   screen_name: string;
//   tab_name: string;
// }

// interface ICommonPropertiesObjGeneratorClosureParams
//   extends ICommonPropertiesObjGeneratorParams {
//   element_name: string;
//   element_type: string;
//   event_category: string;
// }

// export function commonPropertiesObjGenerator({
//   screen_name,
//   tab_name,
// }: ICommonPropertiesObjGeneratorParams) {
//   return ({
//     element_name,
//     element_type,
//     event_category,
//   }: Omit<
//     ICommonPropertiesObjGeneratorClosureParams,
//     "screen_name" | "tab_name"
//   >): ICommonPropertiesObjGeneratorClosureParams => {
//     return {
//       screen_name,
//       tab_name,
//       element_name,
//       element_type,
//       event_category,
//     };
//   };
// }

// export const feedScreenFeedTabCommonPropsForTracker =
//   commonPropertiesObjGenerator({
//     screen_name: "feedScreen",
//     tab_name: "feed_tab",
//   });
